import { render } from "./servingSubItemModel.vue?vue&type=template&id=061766b8"
import script from "./servingSubItemModel.vue?vue&type=script&lang=js"
export * from "./servingSubItemModel.vue?vue&type=script&lang=js"

import "./servingSubItemModel.vue?vue&type=style&index=0&id=061766b8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__